import React, { memo, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import ModalLayout from '../ModalLayout';

export default memo(ViewTemplateDashboardsModal);

function ViewTemplateDashboardsModal(props) {
  const [state, updateState] = useState({
    dashboardSearchTerm: props.dashboardSearchTerm,
  });

  const handleSearch = ({ target: { name, value } }) => {
    updateState({ ...state, [name]: value });
  };

  const filteredDashboards = useMemo(() => {
    return props.templateDashboards.filter(({ name = '' }) => {
      if (!state.dashboardSearchTerm) return true;

      const prunedName = name.toLowerCase().trim();
      const prunedSearch = state.dashboardSearchTerm.toLowerCase().trim();
      return prunedName.includes(prunedSearch);
    });
  }, [state.dashboardSearchTerm]);

  return (
    <ModalLayout isOpen={props.isOpen} toggleModal={props.toggleModal}>
      <ModalHeader className="border-bottom-0" toggle={props.toggleModal}>
        Choose a Dashboard
      </ModalHeader>
      <ModalBody className="py-0 container-fluid d-flex flex-column">
        <div className="row no-gutters">
          <p className="col-12 three-quarter-text text-left">
            Select a dashboard from below to view. You can then set it as the
            default view for your user from the &ldquo;Settings&rdquo; dropdown
            located at the top right of the Asset details page
          </p>
        </div>
        <div className="row no-gutters mb-3">
          <div className="col-12 input-group input-group-sm">
            <input
              aria-label="Dashboard Search"
              aria-describedby="search-icon"
              className="form-control rounded-lg"
              name="dashboardSearchTerm"
              onChange={handleSearch}
              placeholder="Search for dashboards..."
              type="text"
              value={state.dashboardSearchTerm}
            />
            <div className="input-group-append">
              <span
                className="input-group-text bg-transparent border-0 pr-0"
                id="search-icon"
              >
                <FontAwesomeIcon
                  className="text-text-light-gray"
                  icon={faSearch}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="row no-gutters flex-fill position-relative overflow-auto">
          <div className="position-absolute h-100 w-100 container-fluid">
            {filteredDashboards.map((dashboard) => (
              <div className="row" key={dashboard._id}>
                <div className="col-12">
                  <button
                    className="btn btn-link"
                    onClick={() => props.handleDashboardSelected(dashboard)}
                  >
                    {dashboard.name}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border-top-0">
        <button
          className="btn btn-outline-secondary bg-white text-muted shadow-none py-0 px-3"
          onClick={props.toggleModal}
        >
          Cancel
        </button>
      </ModalFooter>
      <style jsx>{`
        .btn:focus {
          outline: none;
        }
      `}</style>
    </ModalLayout>
  );
}

ViewTemplateDashboardsModal.propTypes = {
  dashboardSearchTerm: PropTypes.string,
  handleDashboardSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  templateDashboards: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      gtemplateID: PropTypes.string,
      isDefault: PropTypes.bool,
      name: PropTypes.string,
      orgID: PropTypes.string,
      widgets: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string,
          col: PropTypes.number,
          row: PropTypes.number,
          settings: PropTypes.object,
          sizeX: PropTypes.number,
          sizeY: PropTypes.number,
        })
      ),
    })
  ),
  toggleModal: PropTypes.func,
};
